import React, { useEffect } from "react";
import { useState, useRef } from "react";
import { Bar } from "react-chartjs-2";

import { MDBCardBody, MDBRow, MDBCol } from "mdb-react-ui-kit";
import { StyleSheet } from "@react-pdf/renderer";
import Chart from "chart.js/auto";

import "../../css/ChartCard.css";

const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#E4E4E4",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
});

const options1 = {
  maintainAspectRatio: false,
  responsive: true,
  indexAxis: "x",
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        padding: 8, //default
        font: {
          size: 12,
        },
        z: 0,
      },
    },
    y: {
      grid: {
        display: false,
      },
      type: "linear",
      beginAtZero: true,
      ticks: {
        display: false,
        autoSkip: false,
        maxRotation: 0, // angle in degrees
      },
    },
  },

  plugins: {
    legend: false,
  },
};

const options2 = {
  responsive: true,
  maintainAspectRatio: false,
  indexAxis: "y",

  scales: {
    y: {
      grid: {
        display: false,
      },
      ticks: {
        padding: 0, //default
        font: {
          size: 12,
        },
        z: 0,
      },
    },

    x: {
      grid: {
        display: false,
      },
      type: "linear",
      beginAtZero: true,
      ticks: {
        display: false,
        autoSkip: false,
        maxRotation: 0, // angle in degrees
      },
    },
  },

  plugins: {
    legend: false,
  },
};

function ChartCard({ title, chartInputData, errorMessage }) {
  const [chartDataset, setChartDataset] = useState("");
  const [isEmpty, setisEmpty] = useState(true);
  const [barThickness, setBarThickness] = useState(50);

  useEffect(() => {
    setChartDataset(chartInputData);
  }, [chartInputData]);

  useEffect(() => {
    if (values.length !== 0) {
      setisEmpty(false);
    } else {
      setisEmpty(true);
    }
  });

  useEffect(() => {
    var media = window.matchMedia("(max-width: 1024px)");
    if (media.matches) setBarThickness(30);
    else return setBarThickness(50);
  });

  const newProfile = chartInputData;

  var labels = [];
  var labelData = [];
  var titles = [];
  var values = [];
  var labelDataChart = [{}];
  const chartRef = useRef();
  const chartRef1 = useRef();
  const chartRef2 = useRef();

  if (chartDataset !== "" && chartInputData) {
    titles = Object.keys(chartInputData);
    values = Object.keys(chartInputData).map((c, i) => chartInputData[c]);
    values.shift();
    titles.shift();
    if (values.length !== "0") {
      for (let index = 0; index < chartDataset.length; index++) {
        labelDataChart[index] = chartDataset[index];
      }

      var newLabels = [];
      for (let index = 0; index < titles.length; index++) {
        newLabels[index] = titles[index].toString().match(/.{0,15}(?:\s|$)/g);
      }
      var chartData = {
        labels: newLabels,
        datasets: [
          {
            label: "Competency",
            barThickness: barThickness,
            minBarLength: 5,
            data: values.map((col) => {
              return col;
            }),
            backgroundColor: "rgba(5,80,240,1)",
          },
        ],
      };
    }
  }

  return (
    <>
      <div>
        <h1 className="chartTitle">{title}</h1>
        {chartDataset !== "" && chartInputData ? (
          <MDBRow className="w-100">
            {chartDataset !== "" && (
              <>
                <MDBCol className="w-100">
                  {isEmpty ? (
                    <MDBCardBody>
                      <h6>No Recommended Trainings found!</h6>
                    </MDBCardBody>
                  ) : (
                    <div className="chartContainer">
                      <div className="chartVertical">
                        <Bar
                          id="recTrainChart"
                          options={options1}
                          ref={chartRef1}
                          data={chartData}
                        />
                      </div>
                      <div className="chartHorizontal">
                        <Bar
                          id="recTrainChart"
                          options={options2}
                          ref={chartRef2}
                          data={chartData}
                        />
                      </div>
                    </div>
                  )}
                </MDBCol>
              </>
            )}
          </MDBRow>
        ) : (
          <div>
            <h6>{errorMessage}</h6>
          </div>
        )}
      </div>
    </>
  );
}

export default ChartCard;
